export default "__VITE_ASSET__b5116fbe__"